import axios from "axios";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { EventRegistrationStatus } from "interfaces/events";
import { useEffect, useState } from "react";
import { COLORS_PER_STATUS, LABELS_PER_STATUS } from "./constants";
import { StatusBadge } from "./style";

interface Props {
  eventId: number;
}

const EventStatusBadge: React.FC<Props> = ({ eventId }) => {
  const [eventStatus, setEventStatus] = useState<EventRegistrationStatus>();
  const { currentUser } = useLoginContext();
  useEffect(
    function getEventStatus() {
      if (currentUser?.id)
        axios.get(`/events/${eventId}/registration_status/`).then(response => setEventStatus(response.data));
    },
    [currentUser?.id, eventId]
  );
  if (!currentUser?.id || isCompanyUser(currentUser)) return null;
  // Put a non-breaking space in the badge if the event status is not yet loaded so that it is displayed correctly
  // eslint-disable-next-line no-irregular-whitespace
  if (!eventStatus) return <StatusBadge color="#fff"> </StatusBadge>;
  return <StatusBadge color={COLORS_PER_STATUS[eventStatus]}>{LABELS_PER_STATUS[eventStatus]}</StatusBadge>;
};

export default EventStatusBadge;
